if (!window.Maximize.loadedScript.includes("locales-form.js")) {
  window.Maximize.loadedScript.push("locales-form.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xLocalizationForm", (language) => ({
        localizationForm: "",
        openForm: false,
        openCountry: false,
        openLanguage: false,
        loading: false,
        cachedResults: false,
        currentCountrySelector: '',
        languageSelector: language,
        countrySearchQuery: '',
        noCountryResults: false,
        toggleOpenForm() {
          this.openForm = !this.openForm;
        },
        submit() {
          this.$el.closest("#localization_form").submit();
        },
        loadCountry(el) {
          // Guard against double-tap / rapid re-click while a fetch is already
          // in flight.
          if (this.loading) {
            return;
          }
          let countrySelectorElement = el.closest(".country-selector");
          if (this.cachedResults) {
            // The list is already loaded: from here on Alpine is the single
            // source of truth for open/close on this control (the native
            // select-element's own click handler is disabled for
            // data-select-type="currency-selector" — see custom-elements.js —
            // precisely so the two don't race and fight over the open state,
            // which is what caused the janky/"sballa" toggle behaviour).
            if (countrySelectorElement.isOpen) {
              countrySelectorElement.handleClose();
            } else {
              countrySelectorElement.handleOpen();
            }
            this.openCountry = countrySelectorElement.isOpen;
            return true;
          }
          let optionEL = countrySelectorElement.querySelector(".country-options");
          this.loading = true;
          this.currentCountrySelector = this.$refs.currentCountry.innerText.toLowerCase();
          const _this = this;
          fetch(window.Shopify.routes.root + "?section_id=country-selector")
            .then((reponse) => {
              return reponse.text();
            })
            .then((response) => {
              const parser = new DOMParser();
              const content = parser
                .parseFromString(response, "text/html")
                .getElementById("list-country");

              optionEL.innerHTML = content.innerHTML;
              requestAnimationFrame(() => {
                const countryLists = optionEL.querySelectorAll('li[role="button"]');

                countryLists.forEach(country => {
                  country.addEventListener('click', () => {
                    _this.setSelectCountry(el, country);
                    if (!countrySelectorElement.dataset.showPopup) el.closest("#localization_form").submit();
                  });

                  country.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      _this.setSelectCountry(el, country);
                      if (!countrySelectorElement.dataset.showPopup) el.closest("#localization_form").submit();
                    }
                  });
                });

                // Open the underlying select-element as soon as the list is
                // actually in the DOM, instead of an arbitrary fixed delay.
                this.loading = false;
                countrySelectorElement.handleOpen();
                countrySelectorElement.optionsList.classList.remove("p-0");
              })
              this.cachedResults = true;
              this.openCountry = true;
            })
            .catch(() => {
              this.loading = false;
            });
        },
        handleOptionEvent(currency_selector, rowItem, language, selector) {
          const _this = this;
          this.$el.addEventListener('click', () => {
            _this.setSelectLanguage(rowItem, language, selector);
            if (currency_selector === 'false') _this.submit();
          })
          this.$el.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              _this.setSelectLanguage(rowItem, language, selector);
              if (currency_selector === 'false') _this.submit();
            }
          });
        },
        setSelectLanguage(rowItem, language, selector) {
          this.$el.closest("#localization_form").querySelector("#" + selector).value = language;
          this.languageSelector = rowItem;
          this.openLanguage = false;
        },
        setSelectCountry(el, country) {
          el.closest("#localization_form").querySelector("#currency_selector").value = country.dataset.country;
          this.currentCountrySelector = country.dataset.countryTitle.toLowerCase();
          this.openCountry = false;
          this.resetCountrySearch();
        },
        // Filtra la lista paesi gia' caricata nel DOM in base al testo digitato.
        // Wrapped defensively: a thrown error here previously left the search
        // box looking "frozen" (nothing updates on further keystrokes) because
        // it was an uncaught error inside an Alpine-bound event handler.
        filterCountry(query) {
          try {
            this.countrySearchQuery = query;
            const root = this.$root || this.$el;
            const optionEL = root ? root.querySelector(".country-options") : null;
            if (!optionEL) return;

            const items = optionEL.querySelectorAll('li[role="button"]');
            const q = (query || "").trim().toLowerCase();
            let visibleCount = 0;

            items.forEach((item) => {
              const title = (item.dataset.countryTitle || item.textContent || "").toLowerCase();
              const code = (item.dataset.country || "").toLowerCase();
              const isMatch = !q || title.includes(q) || code.includes(q);
              item.style.display = isMatch ? "" : "none";
              if (isMatch) visibleCount++;
            });

            this.noCountryResults = q.length > 0 && visibleCount === 0;
          } catch (e) {
            this.noCountryResults = false;
          }
        },
        resetCountrySearch() {
          this.countrySearchQuery = "";
          this.noCountryResults = false;
          const root = this.$root || this.$el;
          const optionEL = root ? root.querySelector(".country-options") : null;
          if (optionEL) {
            optionEL.querySelectorAll('li[role="button"]').forEach((item) => {
              item.style.display = "";
            });
          }
          if (this.$refs.countrySearch) this.$refs.countrySearch.value = "";
        },
        initPosition(position) {
          if (this.$el.closest("#x-utility") && position) {
            this.getScrollPosition(position, true)

            window.addEventListener('resize', () => {
              this.getScrollPosition(position, false)
            });
          }
        },
        initEventScroll() {
          const mobile_menu_scroll_ele = document.querySelector('#menu-navigation .scrollbar-body.scrollbar.overflow-y-auto');
          if (mobile_menu_scroll_ele && this.$el.closest('#x-header-mobile')) {
            mobile_menu_scroll_ele.addEventListener("scroll", () => {
              this.openForm = false;
            });
          }
        },
        getScrollPosition(position, loadPage) {
          var container = this.$el.closest(".link-list");
          var itemRect = this.$el.getBoundingClientRect();
          var containerRect = container.getBoundingClientRect();
          var xUtility = document.getElementById("x-utility")
          if (position == 'right') {
            var elementComputedStyle = getComputedStyle(xUtility);
            var padding = loadPage ? parseFloat(elementComputedStyle.paddingRight) : parseFloat(elementComputedStyle.paddingRight);
            let distance = (containerRect.right - itemRect.right) > 0 ? (containerRect.right - itemRect.right) : (itemRect.right - containerRect.right)
            this.$el.nextElementSibling.style.right = distance + padding + "px"
          } else {
            var elementComputedStyle = getComputedStyle(xUtility)
            var padding = loadPage ? 0 : parseFloat(elementComputedStyle.paddingLeft);

            this.$el.nextElementSibling.style.left = itemRect.left - padding +  "px"
          }
        }
      }));
    });
  });
}
